import { MAP_HEX_RADIUS } from "../../models/config/balance.ts";
import {
  DEFAULT_WORLD_BALANCE,
  type WorldBalance,
} from "../../models/config/worldBalance.ts";
import { buildHexGrid } from "../../models/hex/hexGrid.ts";
import { createRngState, pickWeightedIndex } from "../../models/rng/seededRng.ts";
import type { RngState, TileData, TileKey, WorldState } from "../../models/worldState.ts";
import { tileKey } from "../../models/worldState.ts";

function pickTerrain(
  rng: RngState,
  balance: WorldBalance,
): { terrain: TileData["terrain"]; rng: RngState } {
  const weights = balance.terrainSpawnWeights.map((entry) => entry.weight);
  const picked = pickWeightedIndex(weights, rng);
  return {
    terrain: balance.terrainSpawnWeights[picked.index]!.terrain,
    rng: picked.rng,
  };
}

function generateWorldTiles(
  seed: number,
  balance: WorldBalance = DEFAULT_WORLD_BALANCE,
): {
  tiles: Record<TileKey, TileData>;
  rng: RngState;
} {
  let rng = createRngState(seed);
  const tiles: Record<TileKey, TileData> = {};

  for (const { q, r } of buildHexGrid(MAP_HEX_RADIUS)) {
    const picked = pickTerrain(rng, balance);
    rng = picked.rng;
    tiles[tileKey(q, r)] = {
      q,
      r,
      terrain: picked.terrain,
      visibility: "hidden",
      isStartingTile: false,
      foodDepletion: 0,
    };
  }

  return { tiles, rng };
}

export function appendGeneratedTiles(
  state: WorldState,
  seed: number,
  balance: WorldBalance = DEFAULT_WORLD_BALANCE,
): WorldState {
  const generated = generateWorldTiles(seed, balance);
  return {
    ...state,
    tiles: generated.tiles,
    rng: generated.rng,
  };
}
